<div>
    <div class="card-header mb-4">
        <div class="title-section">
            <h3 class="header-title">Clave de Usuario: {{ usuarioData?.userName || 'N/A' }}</h3>
        </div>
        <div class="search-section">
            <div class="button-section">
                <span class="p-input-icon-left search-input">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchTerm" (input)="filtrarNiveles()"
                        placeholder="Buscar..." class="p-inputtext-sm">
                </span>
                <button mat-flat-button (click)="nuevo()" class="btn-new" appPermissionControl="P401B0004">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>
        </div>
    </div>

    <p-table #dt [value]="dataSource" [columns]="columns" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[5, 10, 20, 40, 80]" [scrollable]="true" [scrollHeight]="'calc(100vh - 400px)'"
        styleClass="p-datatable-gridlines" [resizableColumns]="true" [autoLayout]="true" responsiveLayout="scroll"
        [loading]="loading" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        appPermissionControl="P401T0001">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null"
                    class="th-prime">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td *ngFor="let col of columns" class="td-prime">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'linea_autorizacion'">
                            {{ rowData[col.field] | currency:'COP':'symbol':'1.0-0' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'actions'">
                            <div class="d-flex gap-2 justify-content-center">
                                <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-text"
                                    (click)="editar(rowData)" pTooltip="Editar"
                                    appPermissionControl="P401B0005"></button>
                                <button pButton icon="pi pi-trash"
                                    class="p-button-rounded p-button-danger p-button-text" (click)="eliminar(rowData)"
                                    pTooltip="Eliminar" appPermissionControl="P401B0006"></button>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="text-center td-prime">
                    <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
                    <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8"
                        fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Diálogo del formulario -->
<p-dialog [(visible)]="displayDialog" [style]="{ width: '90vw' }" [modal]="true" [draggable]="false" [resizable]="false"
    (onHide)="hideDialog()" [header]="formTitle" appPermissionControl="P401F0001">
    <form [formGroup]="nivelForm" (ngSubmit)="guardarNivel()">
        <div class="form-row">
            <div class="form-field flex-grow-1">
                <input pInputText type="text" formControlName="clave_usuario" class="form-control" readonly
                    appPermissionControl="P401K0017" />
                <label>Clave Usuario</label>
            </div>

            <div class="form-field flex-grow-1 mt-1">
                <p-dropdown formControlName="tipo_Credito" [options]="tiposCreditoOptions" optionLabel="label"
                    optionValue="value" [filter]="true" [showClear]="true" appendTo="body"
                    placeholder="Seleccione tipo de crédito" class="w-100" [disabled]="modoEdicion"
                    appPermissionControl="P401K0018">
                </p-dropdown>
                <label>Tipo de Crédito</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="linea_autorizacion" class="form-control"
                    placeholder="0" step="0.01" min="0" appPermissionControl="P401K0019" />
                <label>Línea de Autorización</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="s_min_scoring" class="form-control" placeholder="0"
                    step="0.01" min="0" appPermissionControl="P401K0020" />
                <label>Min. Scoring</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="s_min_prescoring" class="form-control" placeholder="0"
                    step="0.01" min="0" appPermissionControl="P401K0021" />
                <label>Min. Prescoring</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="vigenciaDias" class="form-control" placeholder="0"
                    min="0" />
                <label>Vigencia Días</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="firmasArriba" class="form-control" placeholder="0"
                    min="0" />
                <label>Firmas Arriba</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="limiteLinea" class="form-control" placeholder="0"
                    step="0.01" min="0" />
                <label>Límite Línea</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="firmas" class="form-control" placeholder="0" min="0" />
                <label>Firmas</label>
            </div>

            <div class="form-field flex-grow-1">
                <input pInputText type="number" formControlName="arribaVigenciaDias" class="form-control"
                    placeholder="0" min="0" />
                <label>Arriba Vigencia Líneas</label>
            </div>
        </div>

        <div class="d-flex gap-4 mb-4">
            <div class="checkbox-field">
                <input type="checkbox" formControlName="mancomunada" id="mancomunada">
                <label for="mancomunada">Mancomunada</label>
            </div>
            <div class="checkbox-field">
                <input type="checkbox" formControlName="mancArriba" id="mancArriba">
                <label for="mancArriba">Manc. Arriba</label>
            </div>
        </div>

        <div class="button-section">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!nivelForm.valid || loading"
                appPermissionControl="P401B0007">
                <mat-icon>{{ loading ? 'sync' : 'save' }}</mat-icon>
                {{ loading ? (modoEdicion ? 'Actualizando...' : 'Guardando...') : modoEdicion ? 'Actualizar' : 'Guardar'
                }}
            </button>
        </div>
    </form>
</p-dialog>